import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AssetResource} from '../../../../class/lifeproject/asset-resource';
import {WelfareResultService} from '../../../../service/welfare-result.service';

@Component({
  selector: 'app-asset-resources',
  templateUrl: './asset-resources.component.html',
  styleUrls: ['./asset-resources.component.css']
})
export class AssetResourcesComponent implements OnInit {

  @Input()
  assets: AssetResource[];

  @Output()
  onTotalChange = new EventEmitter<number>();

  @Input()
  showHomeAssetButton = true;

  total = 0;

  constructor(private welfareService: WelfareResultService) {
  }

  ngOnInit() {
    this.updateTotal();
  }

  pushAsset(asset: AssetResource) {
    if (asset) {
      this.assets.push(asset);
      this.updateTotal();
    }
  }

  updateTotal() {
    this.total = 0;

    if (this.assets.length === 0) {
      this.total = 0;
      this.onTotalChange.emit(this.total);
    } else {
      this.assets.forEach(value => {
        this.total += value.selectedValue;
        this.onTotalChange.emit(this.total);
      });
    }
  }

  resetValue(assetResult: AssetResource) {

    const asset = assetResult.asset;

    asset.usedValue -= assetResult.selectedValue;

    // find object index
    const index: number = this.assets.indexOf(assetResult);

    if (index !== -1) {
      // delete entry
      this.assets.splice(index, 1);
    }

    this.welfareService.subtractAssetUsedValue(assetResult);
    this.updateTotal();
  }
}
